import { useTheme } from "@mui/material/styles";
import React, { useEffect, useRef, useState } from "react";

import { sanitize } from "../../util/html";
import { CaptionsText } from "./Captions.elements";

export default function Captions({ text }: { text: string }): React.ReactElement | null {
  const ref = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState<number>(0);
  const theme = useTheme();

  useEffect(() => {
    if (!ref.current) return;
    const handleResize = (entries: ResizeObserverEntry[]) => {
      for (const entry of entries) {
        setWidth(entry.contentRect.width);
      }
    };
    const observer = new window.ResizeObserver(handleResize);
    observer.observe(ref.current);
    setWidth(ref.current.offsetWidth);
    return () => observer.disconnect();
  }, []);

  const { md, lg } = theme.breakpoints.values;
  let fontSize = "1.4em";
  if (width > lg) fontSize = "1.8em";
  else if (width > md) fontSize = "1.6em";

  return (
    <CaptionsText
      ref={ref}
      data-testid="captions-text"
      fontSize={fontSize}
      dangerouslySetInnerHTML={{ __html: sanitize(text) }}
    />
  );
}
